import React from 'react';

const Partners = () => {
  return (
    <section className="container my-5"><br/><br/>
      <h3 className="text-center mb-5 section-title">Partner Companies</h3>
      <div className="row g-4">
        <div className="col-md-3 col-sm-6">
          <div className="partner-card text-center h-100">
            <i className="fas fa-truck" style={{fontSize: '3rem', color: '#00d4ff', marginBottom: '1rem'}}></i>
            <div className="fw-bold">Nepal Express</div>
          </div>
        </div>
        <div className="col-md-3 col-sm-6">
          <div className="partner-card text-center h-100">
            <i className="fas fa-truck" style={{fontSize: '3rem', color: '#00d4ff', marginBottom: '1rem'}}></i>
            <div className="fw-bold">Himalayan Cargo</div>
          </div>
        </div>
        <div className="col-md-3 col-sm-6">
          <div className="partner-card text-center h-100">
            <i className="fas fa-truck" style={{fontSize: '3rem', color: '#00d4ff', marginBottom: '1rem'}}></i>
            <div className="fw-bold">Mountain Courier</div>
          </div>
        </div>
        <div className="col-md-3 col-sm-6">
          <div className="partner-card text-center h-100">
            <i className="fas fa-truck" style={{fontSize: '3rem', color: '#00d4ff', marginBottom: '1rem'}}></i>
            <div className="fw-bold">Terai Transport</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Partners;
